export default {
  'menu.welcome': '歡迎',
  'menu.home': '首頁',
  'menu.login': '登錄',

  // 系統管理模組
  'menu.system': '系統管理',
  'menu.system.welcome': '系統首頁',
  'menu.system.dict': '字典管理',
  'menu.system.menu': '菜單管理',
  'menu.system.role': '角色管理',
  'menu.system.noAuth': '無認證接口',

  // 事件管理模組
  'menu.event': '事件管理',
  'menu.event.eventManagement': '事件管理',
  'menu.event.eventReceiver': '事件接收者',
  'menu.event.resourceFile': '資源文件',

  // 組織管理模組
  'menu.organization': '組織管理',
  'menu.organization.orgDept': '部門管理',
  'menu.organization.orgPost': '崗位管理',
  'menu.organization.orgTree': '下級組織',
  'menu.organization.employee': '員工管理',
  // 嵌套路由國際化鍵
  'menu.organization.orgTree.orgDept': '部門管理',
  'menu.organization.orgTree.employee': '員工管理',
  'menu.organization.orgTree.orgPost': '崗位管理',

  // 設備管理模組
  'menu.device': '設備管理',
  'menu.device.deviceModel': '設備型號',
  'menu.device.deviceSupplier': '設備供應商',
  'menu.device.deviceGateway': '設備網關',
  'menu.device.deviceTerminal': '設備終端',
  'menu.device.deviceManagement': '設備管理',

  // 套餐管理模組
  'menu.package': '套餐管理',
  'menu.package.myPackage': '我的套餐',
  'menu.package.subPackage': '子級套餐',

  // 用戶管理
  'menu.user': '用戶管理',

  // 視頻融合模塊
  'menu.video': '視頻融合',
  'menu.video.preview': '實時預覽',
  'menu.video.playback': '歷史回放',
  'menu.video.recording': '手動錄像',
};
